export const extractWordFromUrl = (url: string): string | null => {
  const regex = /\/([^/]+)\.html$/;

  const matchResult = url.match(regex);

  if (matchResult && matchResult.length > 1) {
    return matchResult[1];
  } else {
    return null;
  }
};
